import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Detail = lazy(() => import('./Detail'))

//	///////////////////////
//	MARK: EXPORTS
/**
 * ★ Les publications de promotion — `03` §3.10. Préfixe statique pour la fiche : un segment statique
 * bat toujours `:param` (`01` §15.2), et les onglets de la fiche prennent le reste.
 */
export const SafetyPublicationRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--safety--publications']}>
    <Route path='publication/:publicationId/*' element={<Detail />} />
    <Route path='*' element={<Index />} />
  </SubRouter>
))
